import { render, staticRenderFns } from "./McFormCheckboxes.vue?vue&type=template&id=a3d36140"
import script from "./McFormCheckboxes.vue?vue&type=script&lang=js"
export * from "./McFormCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./McFormCheckboxes.vue?vue&type=style&index=0&id=a3d36140&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports